import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CloseIcon from "@mui/icons-material/Close";
import ReplayIcon from "@mui/icons-material/Replay";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  Checkbox,
  ClickAwayListener,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grow,
  Link,
  MenuItem,
  Paper,
  Popper,
  Radio,
  RadioGroup,
} from "@mui/material";
import { format } from "date-fns";
import React, { useCallback, useEffect, useImperativeHandle, useRef, useState, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { USER_GROUP } from "../../../assets/data/UserGroupsData";
import AlarmFillIcon14pxSvg from "../../../assets/images/icons/AlarmFillIcon14pxSvg";
import ArrowRepeatIcon16pxSvg from "../../../assets/images/icons/ArrowRepeatIcon16pxSvg";
import CloudArrowDownIcon16pxSvg from "../../../assets/images/icons/CloudArrowDownIcon16pxSvg";
import CloudArrowUpIcon16pxSvg from "../../../assets/images/icons/CloudArrowUpIcon16pxSvg";
import PencilEditIcon16pxSvg from "../../../assets/images/icons/PencilEditIcon16pxSvg";
import {
  allowAttendance,
  getHistoryRequest,
  getListRequestType,
} from "../../../axios/Eventlog/EventLogApi";
import Combobox from "../../../components/Combobox";
import CustomSelect from "../../../components/CustomSelect";
import PrimaryDivider from "../../../components/PrimaryDivider";
import {
  ControlpanelErrorButton,
  ControlpanelPrimaryButton,
  ControlpanelPurple2thButton,
  ControlpanelSuccess2thButton,
  ControlpanelSuccess3thButton,
  ControlpanelSuccessButton,
  ControlpanelWarning2thButton,
  ControlpanelWarningButton,
} from "../../../components/StyledButton";
import { CustomAdvancedMenuList } from "../../../components/StyledComponents";
import { useAuth } from "../../../context/AuthContext";
import { useLoading } from "../../../context/LoadingContext";
import { useSettings } from "../../../context/SettingsContext";
import QuestionIcon16pxSvg from "./../../../assets/images/icons/QuestionIcon16pxSvg";
import DefaultTooltip from "./../../../components/DefaultTooltip";
import AddEventDialog from "./AddEventDialog";
import ConfirmCheckInOutDialog from "./ConfirmCheckInOutDialog";
import EditEventDialog from "./EditEventDialog";
import EventLogMonthEventsCalendar from "./EventLogMonthEventsCalendar";
import { EVENT_STATUS } from "./EventsGridInfoTable";
import ReEvaluateDialog from "./ReEvaluateDialog";
import RemoveEventDialog from "./RemoveEventDialog";
import RestoreEventsDialog from "./RestoreEventsDialog";
import SelectDataToExportEventlogDialog from "./SelectDataToExportEventlogDialog";
import SelectDataToImportEventlogDialog from "./SelectDataToImportEventlogDialog";
import AddRequestDialog from "./AddRequestDialog";
import EditEventDialogByUser from "./EditEventDialogByUser";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import HistoryDialog from "./HistoryDialog";
import InfoIcon from "@mui/icons-material/Info";
import RequestMonthCalendar from "./RequestMonthCalendar";
import EditRequestDialogByUser from "./EditRequestDialogByUser";
import DetailRequestDialog from "./DetailRequestDialog";
import RemoveRequestDialog from "./RemoveRequestDialog";
import EditRequestEventDialogByUser from "./EditRequestEventDialogByUser";
import { vi, enUS, ta } from "date-fns/locale";
import EventImagesCalendar from "./EventImagesCalendar";
import ArrowDropdownIcon14pxSvg from "../../../assets/images/icons/ArrowDropdownIcon14pxSvg";
import DropdownIcon14pxSvg from "../../../assets/images/icons/DropdownIcon14pxSvg";
import CustomSelectShiftReport from "../../../components/CustomSelectShiftReport";
import CustomTimePicker from "../../../components/CustomTimePickerHaveSecond";
import ImportDataDialog from "../UserManagement/ImportDataDialog";
import AddMultiEventDialog from "./AddMultiEventDialog";
import { getListUserGroup } from "../../../axios/Group/GroupUrlApi";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import DetailRequestDialogAR from "./DetailRequestDialogAR";
import RefreshCircleIcon20pxSvgV2 from "../../../assets/images/icons/RefreshCircleIcon20pxSvgV2";
import { DateTime } from "luxon";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import QuestionIcon16pxSvgWhite from "../../../assets/images/icons/QuestionIcon16pxSvgWhite";
import RemoveRequestEventDialog from "./RemoveRequestEventDialog";
import AddEventFromUndefindedImage from "./AddEventFromUndefindedImage";
import AddUndefindedImageIcon16pxSvg from "../../../assets/images/icons/AddUndefindedImageIcon16pxSvg";
import { updateNotification } from "../../../axios/Notification/NotificationApi";
import { useNotification } from "../../../context/NotificationContext";

dayjs.extend(utc);
dayjs.extend(timezone);

const userGroupsData = USER_GROUP;

const EventLogInfo = forwardRef(({
  info,
  selectedShift,
  selectedUser,
  selectedDate,
  shiftsData,
  usersData,
  onRefresh,
  setSelectedDate,
  setSelectedShift,
  setSelectedUser,
  setIsShowErrorLog,
  refreshData,
  tabName,
  setIsShowErrorIMG,
  devicesData,
  selectDevice,
  setSelectedDevice,
  shiftsDataNoAllShift,
  setSelectStartTime,
  setSelectEndTime,
  isShowErrorIMG,
  groupData,
  errorUserIds,
  handleGetDataFilterEvent,
  setSelectedGroup,
  calculateDisplayedWeeks,
  selectGroup,
  dialogOnly = false,
}, ref) => {
  const { t, i18n } = useTranslation();
  const [show, hide] = useLoading();
  const [searchParams, setSearchParams] = useSearchParams();
  const requestIdParam = searchParams.get("requestId");
  const { settings } = useSettings();
  const [disableCheckInOut, setDisableCheckInOut] = useState(true);
  const currentLang = i18n.language;
  const {
    genaralSettingDateFormat,
    genaralSettingTimeFormat,
    dateTimeFormat,
    profile,
    isEmployee,
    isAdmin,
    genaralSettingTimeZone
  } = useAuth();

  const allShiftIds = shiftsData.map((shift) => shift.shiftId);
  const allDeviceIds = devicesData.map((device) => device.deviceId);
  const allGroupIds = (groupData || []).map(g => g.id);
  const [formData, setFormData] = useState({
    showEvents: { attendance: true, access: false },
    selectedShift: 0,
    selectUserGroup: "IT",
    showOnlyErrorEvent: false,
    groupEvents: "eventTime",
    showOnlyUnknownImages: true,
    selectDevice: 0,
    shift: allShiftIds,
    device: allDeviceIds,
    startTime: "00:00:00",
    endTime: "23:59:00",
    group: groupData?.[0]?.id ?? 1,
  });

  useEffect(() => {
    if (tabName === 2) {
      setFormData(prev => ({
        ...prev,
        showOnlyUnknownImages: true,
      }));
    }
  }, [tabName]);


  useEffect(() => {
    if (shiftsData?.length > 0) {
      setFormData((prevData) => ({
        ...prevData,
        selectedShift: 0,
        selectDevice: 0,
        shift: allShiftIds,
        device: allDeviceIds,
      }));
    }
  }, [shiftsData, devicesData]);

  useEffect(() => {
    handleGetDataFilterEvent(formData);
  }, [formData]);

  const fomatDate = genaralSettingDateFormat
    ? genaralSettingDateFormat
    : "dd/MM/yyyy";

  const dayOfWeek = format(selectedDate, "EEEE", {
    locale: currentLang === "vi" ? vi : enUS,
  });
  const formattedDate = format(selectedDate, fomatDate);
  const [removeEventOpen, setRemoveEventOpen] = useState(false);
  const [requestRemoveEventOpen, setRequestRemoveEventOpen] = useState(false);
  const [openCheckInOut, setOpenCheckInOut] = useState(false);
  const [openEditEvent, setOpenEditEvent] = useState(false);
  const [openAddEvent, setOpenAddEvent] = useState(false);
  const [openAddEventFromUnidentified, setOpenAddEventFromUnidentified] = useState(false);
  const [openRestoreEvents, setOpenRestoreEvents] = useState(false);
  const [openSelectDataToExport, setOpenSelectDataToExport] = useState(false);
  const [openSelectDataToImport, setOpenSelectDataToImport] = useState(false);
  const [openReEvaluate, setOpenReEvaluate] = useState(false);
  const [openAdvancedEventlog, setOpenAdvancedEventlog] = useState(false);
  const anchorRefAdvancedEventlog = useRef(null);
  const [openAddRequest, setOpenAddRequest] = useState(false);
  const [openEditEventByUser, setOpenEditEventByUser] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [requestTypeId, setRequestTypeId] = useState(1);
  const [parsedNewData, setParsedNewData] = useState({});
  const [parsedOldData, setParsedOldData] = useState({});
  const [openEditRequestByUser, setOpenEditRequestByUser] = useState(false);
  const [openRemoveRequestByUser, setOpenRemoveRequestByUser] = useState(false);
  const [openRequestDetail, setOpenRequestDetail] = useState(false);
  const [openRequestDetailAR, setOpenRequestDetailAR] = useState(false);
  const [requestHistory, setRequestHistory] = useState([]);
  const [openEditRequestEvent, setOpenEditRequestEvent] = useState(false);
  const [openAddMissingCheckout, setOpenAddMissingCheckout] = useState(false);
  const [missingCheckoutShiftIds, setMissingCheckoutShiftIds] = useState(null);
  const [selectNewGroup, setSelectedNewGroup] = useState(1);
  const [userGroup, setUserGroup] = useState([]);
  const [userGroup1, setUserGroup1] = useState([]);
  const [requestInfo, setRequestInfo] = useState(null);
  const [openRequestDialog, setOpenRequestDialog] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);

  const fetchedRequestIdRef = useRef(null);

  const parseDateFromRequest = (createdTime) => {
    if (!createdTime) return null;

    return dayjs
      .utc(createdTime)
      .local()
      .startOf("day")
      .toDate();
  };

  useEffect(() => {
    // Hết requestId trên URL → cho phép mở lại cùng id lần sau
    if (!requestIdParam) {
      fetchedRequestIdRef.current = null;
      return;
    }
    if (tabName !== 1) return;
    if (fetchedRequestIdRef.current === requestIdParam) return;

    // Mở popup ngay, dialog tự fetch detail (giống LeaveAndHoliday)
    fetchedRequestIdRef.current = requestIdParam;
    setRequestInfo({ id: Number(requestIdParam) });
    // Chưa biết status → mở PENDING trước; dialog sẽ fetch và hiển thị đúng data.
    setOpenRequestDetail(true);
  }, [requestIdParam, tabName]);

  useEffect(() => {
    fetchedRequestIdRef.current = null;
  }, [tabName]);

  // Mở popup ngay với info hiện có, dialog tự fetch detail + history
  const openRequestDetailDialog = (requestId, openType = "PENDING", rowInfo = null) => {
    setRequestInfo(rowInfo || { id: Number(requestId) });
    setRequestHistory([]);

    if (openType === "PENDING") {
      setOpenRequestDetail(true);
    } else {
      setOpenRequestDetailAR(true);
    }
  };

  const fetchRequestDetail = async (requestId, openType = "PENDING") => {
    // Giữ tên hàm cũ cho chỗ gọi; chỉ mở popup liền, không chờ API
    openRequestDetailDialog(requestId, openType, info?.id === Number(requestId) ? info : { id: Number(requestId) });
  };
  const getMissingCheckoutShiftIds = () =>
    missingCheckoutShiftIds ??
    (formData.shift?.filter((id) => id !== 0) || []);

  const handleOpenAddMissingCheckout = (shiftIds) => {
    const hasMissing =
      (errorUserIds?.missingCheckInUserIds?.length || 0) > 0 ||
      (errorUserIds?.missingCheckOutUserIds?.length || 0) > 0;

    if (!hasMissing) return;

    if (shiftIds?.length) {
      setMissingCheckoutShiftIds(shiftIds);
    }
    setOpenAddMissingCheckout(true);
  };
  const handleCloseAddMissingCheckout = (isRefresh = false) => {
    if (isRefresh) onRefresh();
    setOpenAddMissingCheckout(false);
    setMissingCheckoutShiftIds(null);
  };

  const getUserLabel = useCallback(
    (option) => t("common.content-158", option),
    [t]
  );

  const handleCheckedChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevData) => {
      if (name in prevData.showEvents) {
        return {
          ...prevData,
          showEvents: { ...prevData.showEvents, [name]: checked },
        };
      } else {
        return { ...prevData, [name]: checked };
      }
    });

    if (name === "showOnlyErrorEvent") {
      setIsShowErrorLog(checked);
    }
    if (name === "showOnlyUnknownImages") {
      setIsShowErrorIMG(checked);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "selectedShift") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));

      setSelectedShift(value);
    } else if (name === "selectDevice") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
      setSelectedDevice(value);
    } else if (name === "group") {
      setFormData((prev) => ({
        ...prev,
        group: value,
      }));
      setSelectedGroup?.(value);
      setSelectedNewGroup?.(value);
      return;
    }
    else if (name === "shift") {
      const selected = Array.isArray(value) ? value : [value];

      // 🔹 Danh sách ca "thật" (bỏ All shift có id = 0)
      const realShifts = shiftsData.filter((s) => s.shiftId !== 0);

      // 🔹 Nếu chỉ có 1 ca duy nhất ⇒ luôn coi như chọn tất cả
      if (realShifts.length === 1) {
        const onlyShiftId = realShifts[0].shiftId;

        setFormData((prev) => ({
          ...prev,
          shift: [0, onlyShiftId], // 0 = All shift, onlyShiftId = ca duy nhất
        }));
        return;
      }

      const isSelectingAll = selected.includes(0);
      const wasSelectingAll = formData.shift.includes(0);

      if (isSelectingAll && !wasSelectingAll) {
        // ✅ Chọn All shift → thêm toàn bộ shiftId + 0, nhưng loại trùng
        const allIds = [...new Set([0, ...shiftsData.map((s) => s.shiftId)])];
        setFormData((prev) => ({
          ...prev,
          shift: allIds,
        }));
      } else if (!isSelectingAll && wasSelectingAll) {
        // ✅ Bỏ chọn All shift
        setFormData((prev) => ({
          ...prev,
          shift: [],
        }));
      } else if (wasSelectingAll && isSelectingAll) {
        // ✅ Đang giữ All shift, click lại All ⇒ reset
        setFormData((prev) => ({
          ...prev,
          shift: [],
        }));
      } else if (!wasSelectingAll && !isSelectingAll) {
        // ✅ Chọn thường (giữ đúng behaviour cũ của bạn)
        if (formData.shift.length === 0) {
          setFormData((prev) => ({
            ...prev,
            shift: [selected[selected.length - 1]],
          }));
        } else if (selected.length === 1) {
          setFormData((prev) => ({
            ...prev,
            shift: selected,
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            shift: [selected[selected.length - 1]],
          }));
        }
      }
    } else if (name === "device") {
      const selected = Array.isArray(value) ? value : [value];
      const isSelectingAll = selected.includes(0);
      const wasSelectingAll = formData.device.includes(0);

      if (isSelectingAll && !wasSelectingAll) {
        // ✅ Chọn "All device" → set tất cả ID (bao gồm 0), loại trùng
        const allIds = [...new Set([0, ...devicesData.map((d) => d.deviceId)])];
        setFormData((prev) => ({
          ...prev,
          device: allIds,
        }));
      } else if (!isSelectingAll && wasSelectingAll) {
        // ✅ Bỏ chọn "All device"
        setFormData((prev) => ({
          ...prev,
          device: [],
        }));
      } else if (wasSelectingAll && isSelectingAll) {
        // ✅ Click lại "All device" → reset
        setFormData((prev) => ({
          ...prev,
          device: [],
        }));
      } else if (!wasSelectingAll && !isSelectingAll) {
        // ✅ Chọn thường
        if (formData.device.length === 0) {
          setFormData((prev) => ({
            ...prev,
            device: [selected[selected.length - 1]],
          }));
        } else if (selected.length === 1) {
          setFormData((prev) => ({
            ...prev,
            device: selected,
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            device: [selected[selected.length - 1]],
          }));
        }
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    setSelectedShift(formData.shift.includes(0) ? 0 : formData.shift.join(","));
    setSelectedDevice(
      formData.device.includes(0) ? 0 : formData.device.join(",")
    );
  }, [formData]);

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        group: selectNewGroup,
        pageNo: 1,
        recordPerPage: 50000,
        langId: localStorage.getItem("i18nextLngId")
      }
      show()
      try {
        const response = await getListUserGroup(payload);
        setUserGroup(response.data.data)

      } catch (error) {
        if (error.response) {
          if (error.response.status !== 401) {
            toast.error(t(error?.response.data.message));
          }
        } else {
          toast.error(t('common.network-timeout'));
        }
      } finally {
        hide()
      }
    };
    fetchData();

  }, [selectNewGroup, t]);

  useEffect(() => {
    const fetchData1 = async () => {
      const payload = {
        group: 1,
        pageNo: 1,
        recordPerPage: 50000,
        langId: localStorage.getItem("i18nextLngId")
      }
      show()
      try {
        const response = await getListUserGroup(payload);
        setUserGroup1(response.data.data)

      } catch (error) {
        if (error.response) {
          if (error.response.status !== 401) {
            toast.error(t(error?.response.data.message));
          }
        } else {
          toast.error(t('common.network-timeout'));
        }
      } finally {
        hide()
      }
    };
    fetchData1();

  }, [t]);

  useEffect(() => {
    if ((info && info.newData) || info.oldData) {
      try {
        setParsedNewData(JSON.parse(info.newData));
        setParsedOldData(JSON.parse(info.oldData));
      } catch (error) {
        console.error("Lỗi parse newData:", error);
        setParsedNewData(null);
        setParsedOldData(null);
      }
    }
  }, [info]);

  const checkAllowAttendance = async () => {
    if (!profile.userId) return;

    const { data } = await allowAttendance(
      profile.userId,
      localStorage.getItem("i18nextLngId")
    );

    setDisableCheckInOut(!data);
  };

  useEffect(() => {
    checkAllowAttendance();
  }, [profile.userId, refreshData]);


  const handleToggleAdvancedEventlog = () => {
    setOpenAdvancedEventlog(!openAdvancedEventlog);
  };

  const getRequestType = async () => {
    try {
      const response = await getListRequestType(
        localStorage.getItem("i18nextLngId")
      );
      const item = response.data.data.find(
        (obj) => obj.name === "ADD_EVENT_LOG"
      );
      if (item) {
        setRequestTypeId(item.id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRequestHistory = async () => {
    const payload = {
      requestId: info.id,
      langId: localStorage.getItem("i18nextLngId"),
    };
    try {
      const response = await getHistoryRequest(payload);
      setRequestHistory(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getRequestType();
  }, []);

  useEffect(() => {
    if (tabName === 1 && info) {
      fetchRequestHistory();
    }
  }, [info, tabName]);

  const handleCloseAdvancedEventlog = (event) => {
    if (
      anchorRefAdvancedEventlog.current &&
      anchorRefAdvancedEventlog.current.contains(event.target)
    ) {
      return;
    }
    setOpenAdvancedEventlog(false);
  };

  const handleOpenReEvaluate = () => {
    setOpenReEvaluate(true);
  };

  const handleCloseReEvaluate = () => {
    setOpenReEvaluate(false);
  };

  const handleOpenSelectDataToImport = () => {
    setOpenSelectDataToImport(true);
  };

  const handleCloseSelectDataToImport = () => {
    setOpenSelectDataToImport(false);
  };

  const handleOpenSelectDataToExport = () => {
    setOpenSelectDataToExport(true);
  };

  const handleCloseSelectDataToExport = () => {
    setOpenSelectDataToExport(false);
  };

  const handleOpenRestoreEvents = () => {
    setOpenRestoreEvents(true);
  };

  const handleCloseRestoreEvents = () => {
    setOpenRestoreEvents(false);
  };

  const handleOpenAddEvent = () => {
    setOpenAddEvent(true);
  };

  const handleCloseAddEvent = () => {
    setOpenAddEvent(false);
  };

  const handleOpenEditEvent = () => {
    setOpenEditEvent(true);
  };

  const handleCloseEditEvent = () => {
    setOpenEditEvent(false);
  };

  const handleOpenAddEventFromUnidentified = () => {
    setOpenAddEventFromUnidentified(true);
  };

  const handleCloseAddEventFromUnidentified = () => {
    setOpenAddEventFromUnidentified(false);
  };

  const handleOpenCheckInOut = () => {
    setOpenCheckInOut(true);
  };

  const handleCloseCheckInOut = async (isRefresh = false) => {
    if (isRefresh) {
      await onRefresh();
      await checkAllowAttendance(); // ✅ hỏi lại backend
    }

    setOpenCheckInOut(false);
  };


  const handleOpenRemoveEvent = () => {
    setRemoveEventOpen(true);
  };

  const handleOpenRequestRemoveEvent = () => {
    setRequestRemoveEventOpen(true);
  };

  const handleCloseRemoveEvent = async (isRefresh = false) => {
    if (isRefresh) {
      await onRefresh();
      await checkAllowAttendance();
    }

    setRemoveEventOpen(false);
  };


  const skipAllowAttendanceRef = useRef(false);

  const handleCloseRequestRemoveEvent = async (isRefresh = false) => {
    if (isRefresh) {
      await onRefresh();
      await checkAllowAttendance();
    }

    setRequestRemoveEventOpen(false);
  };

  const handleOpenAddRequest = () => {
    setOpenAddRequest(true);
  };

  const handleCloseAddRequest = () => {
    setOpenAddRequest(false);
  };

  const handleOpenEditEventByUser = () => {
    setOpenEditEventByUser(true);
  };

  const handleCloseEditEventByUser = () => {
    setOpenEditEventByUser(false);
  };

  const handleClickShowHistory = () => {
    setShowHistory(true);
  };

  const handleCloseShowHistory = () => {
    setShowHistory(false);
  };

  const handleOpenDetailEvent = () => {
    setShowDetail(true);
  };

  const handleCloseDetailEvent = () => {
    setShowDetail(false);
  };

  const handleOpenEditRequestByUser = () => {
    setOpenEditRequestByUser(true);
  };
  const handleCloseEditRequestByUser = () => {
    setOpenEditRequestByUser(false);
  };
  const handleOpenRemoveRequestByUser = () => {
    setOpenRemoveRequestByUser(true);
  };
  const handleCloseRemoveRequestByUser = () => {
    setOpenRemoveRequestByUser(false);
  };
  const handleOpenRequestDetail = () => {
    setOpenRequestDetail(true);
  };
  const handleCloseRequestDetail = () => {
    setOpenRequestDetail(false);
    setRequestInfo(null); // 🔥 reset
    fetchedRequestIdRef.current = null;

    const params = new URLSearchParams(searchParams);
    params.delete("requestId");
    setSearchParams(params);
  };

  const handleOpenRequestDetailAR = () => {
    setOpenRequestDetailAR(true);
  };
  const handleCloseRequestDetailAR = () => {
    setOpenRequestDetailAR(false);
    setRequestInfo(null);
    fetchedRequestIdRef.current = null;
    const params = new URLSearchParams(searchParams);
    params.delete("requestId");
    setSearchParams(params);
  };
  const handleOpenEditRequestEventByUser = () => {
    setOpenEditRequestEvent(true);
  };
  const handleCloseEditRequestEventByUser = () => {
    setOpenEditRequestEvent(false);
  };

  const currentInfo = requestInfo || info;
  const isInfoEmpty =
    !currentInfo || Object.keys(currentInfo).length === 0;

  const statusTemplate = (status) => {
    const label = t(`attendance.${status}`);
    const missingEvent = info?.missingEvent !== EVENT_STATUS.checkInOut;
    const missingLabel = `(${t(`attendance.${info?.missingEvent}`)})`;

    const today = new Date();
    today.setHours(0, 0, 0, 0); // đặt giờ về 0 để so sánh theo ngày

    const selected = new Date(selectedDate);
    selected.setHours(0, 0, 0, 0);

    const showMissing = missingEvent && selected < today;

    switch (status) {
      case "CHECK_OUT":
        return (
          <div className="text-blue-500 flex items-center gap-1.5 uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-blue-500"></span>
            <p className="text-xs font-bold leading-5">{label}</p>
            {showMissing && (
              <p className="text-xs font-bold text-red-500 leading-5">
                {missingLabel}
              </p>
            )}
          </div>
        );

      case "CHECK_IN":
        return (
          <div className="text-green-500 flex items-center gap-1.5 uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-green-500"></span>
            <p className="text-xs font-bold leading-5">{label}</p>
            {showMissing && (
              <p className="text-xs font-bold text-red-500 leading-5">
                {missingLabel}
              </p>
            )}
          </div>
        );

      default:
        return (
          <div className="text-yellow-500 flex items-center gap-1.5 uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-yellow-500"></span>
            <p className="text-xs font-bold leading-5">{label}</p>
          </div>
        );
    }
  };

  const statusRequest = (status) => {
    switch (status) {
      case "PENDING":
        return (
          <div className="text-yellow-500 flex items-center gap-1.5 uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-yellow-500"></span>
            <p className="text-xs font-bold leading-5">
              {t("common.pending-request")}
            </p>
            {/* <p className='text-xs font-bold text-yellow-500 leading-5'>{missingLabel}</p> */}
          </div>
        );

      case "REJECTED":
        return (
          <div className="text-red-500 flex items-center gap-1.5 uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-red-500"></span>
            <p className="text-xs font-bold leading-5">
              {t("common.rejected")}
            </p>
            {/* <p className='text-xs font-bold text-red-500 leading-5'>{missingLabel}</p> */}
          </div>
        );

      default:
        return (
          <div className="text-green-500 flex items-center gap-1.5 uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-green-500"></span>
            <p className="text-xs font-bold leading-5">
              {t("common.approved")}
            </p>
          </div>
        );
    }
  };

  const EmployeeInfo = ({ info, userData, profile }) => {
    let user;

    if (isAdmin) {
      // user = info;
      user =
        tabName === 0 ? info : userData.find((u) => u.userId === info.userId);
    } else if (isEmployee && tabName === 0) {
      user = info;
    } else {
      user = profile;
    }
    return (
      <p className="text-base font-semibold">
        {user ? `${user.fullName}` : t("common.no-employee")}
      </p>
    );
  };

  const handleDataChange = (name, newData) => {
    if (name === "startTime") {
      setSelectStartTime(newData);
    } else if (name === "endTime") {
      setSelectEndTime(newData);
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: newData,
    }));
  };

  const hasErrorRows =
    errorUserIds &&
    (
      (errorUserIds.missingCheckInUserIds?.length || 0) > 0 ||
      (errorUserIds.missingCheckOutUserIds?.length || 0) > 0
    );

  const displayTime = (timeStr, timeZone) => {
    if (!timeStr) return "";
    return DateTime.fromFormat(timeStr, "yyyy-MM-dd HH:mm:ss", { zone: timeZone })
      .toFormat("HH:mm:ss");
  };

  function displayTimeFromUTC(utcTime) {
    if (!utcTime) return "";

    return dayjs
      .utc(utcTime)           // parse UTC
      .local()                // convert sang timezone client
      .format("HH:mm:ss");    // format
  }

  const displayTimeFromUTCWithTZ = (utcString, timeZone) => {
    if (!utcString) return "";

    const date = new Date(utcString);

    // parse +07:00
    const sign = timeZone.startsWith("-") ? -1 : 1;
    const [hh, mm] = timeZone.slice(1).split(":").map(Number);
    const offsetMs = sign * (hh * 60 + mm) * 60 * 1000;

    // ❗ DÙNG getUTC*
    const utcMs =
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds()
      );

    const local = new Date(utcMs + offsetMs);

    return `${String(local.getUTCHours()).padStart(2, "0")}:${String(
      local.getUTCMinutes()
    ).padStart(2, "0")}:${String(local.getUTCSeconds()).padStart(2, "0")}`;
  };

  const displayTimeByMachineTZ = (utcString) => {
    const d = new Date(utcString);
    return d.toLocaleTimeString("en-GB", { hour12: false });
  };

  const browserTZ = dayjs.tz.guess();

  const displayTimeByCompanyTZ = (utcString, browserTZ) => {
    if (!utcString) return "";

    let tz = browserTZ;

    try {
      return dayjs
        .utc(utcString)
        .tz(tz)
        .format("HH:mm:ss");
    } catch (e) {
      // fallback nếu timezone invalid hoặc chưa sẵn sàng
      return dayjs
        .utc(utcString)
        .local()
        .format("HH:mm:ss");
    }
  };

  const shiftId = formData.shift?.[0];

  const hasValidUser = Boolean(info?.userId);

  const { notifications } = useNotification();

  const markNotificationRead = async (requestId) => {
    try {

      const role = isAdmin ? "ADMIN" : "USER";

      const updated = notifications.map(n =>
        n.id === requestId ? { ...n, unread: false } : n
      );

      await updateNotification(updated, profile.userId, role, profile.companyId);
      onRefresh();

    } catch (e) {
      console.error(e);
    }
  };

  useImperativeHandle(ref, () => ({
    openAddEvent: handleOpenAddEvent,
    openAddRequest: handleOpenAddRequest,
    openCheckInOut: handleOpenCheckInOut,
    openAddEventFromUnidentified: handleOpenAddEventFromUnidentified,
    openRestoreEvents: handleOpenRestoreEvents,
    openSelectDataToImport: handleOpenSelectDataToImport,
    openSelectDataToExport: handleOpenSelectDataToExport,
    openAddMissingCheckout: handleOpenAddMissingCheckout,
  }));

  if (dialogOnly) {
    return (
      <>
        {openReEvaluate && (
          <ReEvaluateDialog
            selectedDate={selectedDate}
            onClose={handleCloseReEvaluate}
          />
        )}
        {openSelectDataToImport && (
          <ImportDataDialog
            onClose={handleCloseSelectDataToImport}
            usersData={usersData}
            shiftsData={shiftsData}
            onRefresh={onRefresh}
          />
        )}
        {openSelectDataToExport && (
          <SelectDataToExportEventlogDialog
            onClose={handleCloseSelectDataToExport}
          />
        )}
        {openRestoreEvents && (
          <RestoreEventsDialog onClose={handleCloseRestoreEvents} />
        )}
        {openAddEvent && (
          <AddEventDialog
            open={openAddEvent}
            onClose={handleCloseAddEvent}
            usersData={usersData}
            shiftsData={shiftsDataNoAllShift}
            onRefresh={onRefresh}
            selectedDate={selectedDate}
          />
        )}
        {openAddEventFromUnidentified && (
          <AddEventFromUndefindedImage
            onClose={handleCloseAddEventFromUnidentified}
            usersData={usersData}
            shiftsData={shiftsDataNoAllShift}
            onRefresh={onRefresh}
            selectedDate={selectedDate}
          />
        )}
        {openAddMissingCheckout && (
          <AddMultiEventDialog
            onClose={handleCloseAddMissingCheckout}
            usersData={usersData}
            shiftsData={shiftsDataNoAllShift}
            onRefresh={onRefresh}
            selectedDate={selectedDate}
            preselectedUserIds={errorUserIds}
            preselectedShiftIds={getMissingCheckoutShiftIds()}
          />
        )}
        {openEditEvent && (
          <EditEventDialog
            onClose={handleCloseEditEvent}
            usersData={usersData}
            shiftsData={shiftsDataNoAllShift}
            onRefresh={onRefresh}
            info={info}
          />
        )}
        {openCheckInOut && (
          <ConfirmCheckInOutDialog onClose={handleCloseCheckInOut} shiftId={shiftId} />
        )}
        {removeEventOpen && (
          <RemoveEventDialog
            userId={profile?.userId}
            onClose={handleCloseRemoveEvent}
            onRefresh={onRefresh}
            info={info}
          />
        )}
        {requestRemoveEventOpen && (
          <RemoveRequestEventDialog
            userId={profile?.userId}
            onClose={handleCloseRequestRemoveEvent}
            onRefresh={onRefresh}
            info={info}
          />
        )}
        {openAddRequest && (
          <AddRequestDialog
            onClose={handleCloseAddRequest}
            usersData={usersData}
            shiftsData={shiftsDataNoAllShift}
            onRefresh={onRefresh}
            info={profile}
            requestTypeId={requestTypeId}
            selectedDate={selectedDate}
          />
        )}
        {openEditEventByUser && (
          <EditEventDialogByUser
            onClose={handleCloseEditEventByUser}
            usersData={usersData}
            shiftsData={shiftsDataNoAllShift}
            onRefresh={onRefresh}
            info={info}
          />
        )}
        {openEditRequestByUser && (
          <EditRequestDialogByUser
            onClose={handleCloseEditRequestByUser}
            usersData={usersData}
            shiftsData={shiftsDataNoAllShift}
            onRefresh={onRefresh}
            info={info}
            tabName={tabName}
            parsedNewData={parsedNewData}
            parsedOldData={parsedOldData}
          />
        )}
        {showHistory && (
          <HistoryDialog
            onClose={handleCloseShowHistory}
            onRefresh={onRefresh}
            requestHistory={requestHistory}
          />
        )}
        {openRequestDetail && requestInfo && (
          <DetailRequestDialog
            onClose={handleCloseRequestDetail}
            usersData={usersData}
            shiftsData={shiftsDataNoAllShift}
            onRefresh={onRefresh}
            info={requestInfo}
            tabName={tabName}
            parsedNewData={parsedNewData}
            parsedOldData={parsedOldData}
            requestHistory={requestHistory}
            onStatusResolved={(data) => {
              setRequestInfo(data);
              setOpenRequestDetail(false);
              setOpenRequestDetailAR(true);
              if (data.createdTime) {
                setSelectedDate(parseDateFromRequest(data.createdTime));
              }
            }}
          />
        )}
        {openRequestDetailAR && requestInfo && (
          <DetailRequestDialogAR
            onClose={handleCloseRequestDetailAR}
            usersData={usersData}
            shiftsData={shiftsDataNoAllShift}
            onRefresh={onRefresh}
            info={requestInfo}
            tabName={tabName}
            parsedNewData={parsedNewData}
            parsedOldData={parsedOldData}
            requestHistory={requestHistory}
          />
        )}
        {openRemoveRequestByUser && (
          <RemoveRequestDialog
            onClose={handleCloseRemoveRequestByUser}
            onRefresh={onRefresh}
            info={info}
          />
        )}
        {openEditRequestEvent && (
          <EditRequestEventDialogByUser
            onClose={handleCloseEditRequestEventByUser}
            usersData={usersData}
            shiftsData={shiftsDataNoAllShift}
            onRefresh={onRefresh}
            info={info}
            tabName={tabName}
            parsedNewData={parsedNewData}
            parsedOldData={parsedOldData}
          />
        )}
      </>
    );
  }

  return (
    <div className="event-log-info">
      <div className="flex justify-between gap-3">
        <div className="flex gap-3">
          <ControlpanelSuccess3thButton onClick={onRefresh}>
            <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
            <p className="hidden md:block">{t("button.refresh-data")}</p>
          </ControlpanelSuccess3thButton>
          <ControlpanelWarning2thButton
            style={{ opacity: "0.5", pointerEvents: "none" }}
          >
            <DropdownIcon14pxSvg />
            <p className="hidden md:block">{t("button.re-evaluate")}</p>
          </ControlpanelWarning2thButton>
        </div>
        <div
          className="flex items-center gap-3"
          style={{ display: isEmployee ? "none" : "" }}
        >
          <DefaultTooltip
            readMore={true}
            title={t("tool-tip.manage-event-logs")}
            content={
              <div className="flex flex-col gap-3">
                <p>
                  {t(
                    "tool-tip.event-logs-can-administrator-to-add-edit-delete"
                  )}
                  .
                </p>
              </div>
            }
          >
            <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
          </DefaultTooltip>

          <ControlpanelPrimaryButton
            // disableRipple
            onClick={handleToggleAdvancedEventlog}
            ref={anchorRefAdvancedEventlog}
            id="advanced-event-log-button"
            aria-controls={
              openAdvancedEventlog ? "advanced-event-log-menu" : undefined
            }
            aria-expanded={openAdvancedEventlog ? "true" : undefined}
            aria-haspopup="true"
          >
            <SettingsIcon />
            <ArrowDropDownIcon className="!text-[20px]" />
          </ControlpanelPrimaryButton>

          <Popper
            open={openAdvancedEventlog}
            anchorEl={anchorRefAdvancedEventlog.current}
            role={undefined}
            placement="bottom-start"
            transition
            disablePortal
            className="z-10"
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "left top" : "left bottom",
                }}
              >
                <Paper style={{ borderRadius: "8px", }}>
                  <ClickAwayListener onClickAway={handleCloseAdvancedEventlog}>
                    <CustomAdvancedMenuList
                      id="advanced-event-log-menu"
                      aria-labelledby="advanced-event-log-button"
                    >
                      <MenuItem
                        style={{
                          borderBottom: "1px solid #E5E7EB",
                          pointerEvents: "auto",
                        }}
                        onClick={(e) => {
                          handleOpenAddEventFromUnidentified();
                          handleCloseAdvancedEventlog(e);
                        }}
                      >
                        <Link>
                          <AddUndefindedImageIcon16pxSvg className="!text-[20px]" />
                          <p>{t("button.add-undefined-image")}</p>
                        </Link>
                      </MenuItem>
                      {/* <MenuItem
                        style={{
                          borderBottom: "1px solid #E5E7EB",
                          opacity: "0.5",
                          pointerEvents: "none",
                        }}
                        onClick={(e) => {
                          handleOpenReEvaluate();
                          handleCloseAdvancedEventlog(e);
                        }}
                      >
                        <Link>
                          <ImportExportIcon className="!text-[20px]" />
                          <p>{t("button.re-evaluate")}</p>
                        </Link>
                      </MenuItem> */}
                      <MenuItem
                        style={{
                          borderBottom: "1px solid #E5E7EB",
                          pointerEvents: "auto",
                        }}
                        onClick={(e) => {
                          handleOpenSelectDataToImport();
                          handleCloseAdvancedEventlog(e);
                        }}
                      >
                        <Link>
                          <CloudArrowUpIcon16pxSvg />
                          <p>{t("button.import-data")}</p>
                        </Link>
                      </MenuItem>
                      <MenuItem
                        style={{ opacity: "0.5", pointerEvents: "none" }}
                        onClick={(e) => {
                          handleOpenSelectDataToExport();
                          handleCloseAdvancedEventlog(e);
                        }}
                      >
                        <Link>
                          <CloudArrowDownIcon16pxSvg />
                          <p>{t("button.export-data")}</p>
                        </Link>
                      </MenuItem>
                      <MenuItem
                        style={{
                          borderBottom: "1px solid #E5E7EB",
                          opacity: "0.5",
                          pointerEvents: "none",
                        }}
                        onClick={(e) => {
                          handleOpenRestoreEvents();
                          handleCloseAdvancedEventlog(e);
                        }}
                      >
                        <Link>
                          <ReplayIcon className="!text-[20px]" />
                          <p>{t("button.restore-events")}</p>
                        </Link>
                      </MenuItem>
                    </CustomAdvancedMenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>

      <div className="my-3">
        <PrimaryDivider />
      </div>

      {(isEmployee || isAdmin) && (tabName === 0 || tabName === 1) && (
        <div className="flex gap-3">
          {(
            <ControlpanelPrimaryButton
              onClick={handleOpenAddRequest}
              sx={{
                borderRadius: "8px",
                textDecoration: "none",
              }}
            >
              <AddIcon />
              <p className="mr-1">{t("common.request")}</p>
              <div className="hidden md:block"><DefaultTooltip
                title={t('common.request')}
                readMore={true}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t('tool-tip.request-des')}</p>
                  </div>
                }
              >
                <QuestionIcon16pxSvgWhite />
              </DefaultTooltip></div>
            </ControlpanelPrimaryButton>
          )}

          {isAdmin && (tabName === 0 || tabName === 1) && (
            <>
              <ControlpanelSuccessButton onClick={handleOpenAddEvent}>
                <AddIcon />
                <p className="mr-1">{t("common.add-events")}</p>
                <div className="hidden md:block">
                  <DefaultTooltip
                    title={t('common.add-events')}
                    readMore={true}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t('tool-tip.add-request-des')}</p>
                      </div>
                    }
                  >
                    <QuestionIcon16pxSvgWhite />
                  </DefaultTooltip>
                </div>
              </ControlpanelSuccessButton>
            </>
          )}
          {(tabName === 0 || tabName === 1) && (
            <>
              <ControlpanelPurple2thButton
                onClick={handleOpenCheckInOut}
                disabled={disableCheckInOut}
              >
                <AlarmFillIcon14pxSvg className="fill-[#A855F7]" />
                <p className="hidden md:block">{t("common.content-112")}</p>
              </ControlpanelPurple2thButton>
            </>
          )}
        </div>
      )}

      <div className="show-events pt-2">
        {(tabName === 0 || tabName === 2) && (
          <>
            <p style={{ display: isEmployee ? "none" : "" }}>
              {t("common.show-events")}
            </p>
            <FormGroup row={true}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.showEvents.attendance}
                    onChange={handleCheckedChange}
                    name="attendance"
                    disableRipple
                    disabled={tabName === 0 || tabName === 2} // 👈 disable riêng
                  />
                }
                label={t("common.attendance")}
                sx={{ opacity: tabName === 0 || tabName === 2 ? 0.5 : 1 }}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.showEvents.access}
                    onChange={handleCheckedChange}
                    name="access"
                    disableRipple
                    disabled={tabName === 0 || tabName === 2} // 👈 disable riêng
                  />
                }
                label={t("common.access")}
                sx={{ opacity: tabName === 0 || tabName === 2 ? 0.5 : 1 }}
              />

              {/* 👇 cái này vẫn hoạt động bình thường */}
              {tabName === 2 && (<FormControlLabel
                control={<Checkbox
                  id="showOnlyUnknownImages"
                  checked={formData.showOnlyUnknownImages}
                  onChange={handleCheckedChange}
                  name="showOnlyUnknownImages"
                />}
                label={t("common.show-only-unknown-images")}
              />)}
            </FormGroup>
          </>
        )}


        <div className="flex md:flex-row flex-col md:justify-between md:items-center gap-1">
          {tabName === 0 && (
            <>
              <p className="w-20 block sm:inline lg:w-auto">
                {t("common.select-shift")}
              </p>

              <FormControl className="md:w-[300px] w-full">
                <CustomSelectShiftReport
                  multiple={true}
                  className="overflow-hidden whitespace-nowrap text-ellipsis"
                  name="shift"
                  value={formData.shift}
                  onChange={handleInputChange}
                  options={shiftsData}
                  dataType="shift"
                  sx={{
                    "& .MuiSelect-select": {
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      paddingRight: "5rem !important", // chừa chỗ cho icon mũi tên
                    },
                    "& .MuiSelect-icon": {
                      right: "0.5rem", // chỉnh icon không đè chữ
                    },
                  }}
                />
              </FormControl>
            </>
          )}
        </div>

        <div className="flex md:flex-row flex-col md:justify-between md:items-center gap-2">
          {tabName === 2 && (
            <>
              <p className="w-20 block sm:inline lg:w-auto">
                {t("common.select-device")}
              </p>

              <FormControl className="md:w-[300px] w-full">
                <CustomSelectShiftReport
                  name="device"
                  multiple={true}
                  className="overflow-hidden whitespace-nowrap text-ellipsis"
                  value={formData.device}
                  onChange={handleInputChange}
                  options={devicesData}
                  dataType="device"
                />
              </FormControl>
            </>
          )}
        </div>

        {tabName === 0 && (
          <>
            <div
              className="flex md:flex-row flex-col md:justify-between md:items-center mt-2 gap-2"
              style={{ display: isEmployee ? "none" : "" }}
            >
              <p className=" block :w-auto">
                {t("common.select-user-group")}
              </p>

              <FormControl className="md:w-[300px] w-full">
                <CustomSelect
                  name="group"
                  id="group"
                  value={formData.group}
                  onChange={handleInputChange}
                  options={groupData}
                  dataType="group"
                // disabled={true}
                />
              </FormControl>
            </div>
          </>
        )}
        {tabName === 0 && (
          <>
            <div
              className="flex md:flex-row flex-col md:justify-between md:items-center mt-2 gap-2"
              style={{ display: isEmployee ? "none" : "" }}
            >
              <p className="w-auto block">
                {t("common.find-user")}
              </p>

              <Combobox
                className={`md:!w-[300px] w-full ${tabName === 2 ? "opacity-50 pointer-events-none" : ""
                  }`}
                options={userGroup}
                placeholder={t("common.content-161")}
                getLabel={getUserLabel}
                onChange={(value) => {
                  window.history.replaceState({}, "");
                  setSelectedUser(value);
                }}
                value={selectedUser}
                inputHeight={40}
              />
            </div>
          </>
        )}
        {tabName === 1 && (
          <>
            <div
              className="flex justify-between items-center mt-3 gap-2"
              style={{ display: isEmployee ? "none" : "" }}
            >
              <p className="w-20 block sm:inline lg:w-auto">
                {t("common.select-user")}
              </p>

              <Combobox
                className={`!w-[300px] ${tabName === 2 ? "opacity-50 pointer-events-none" : ""
                  }`}
                options={userGroup1}
                placeholder={t("common.content-161")}
                getLabel={getUserLabel}
                onChange={(value) => {
                  window.history.replaceState({}, "");
                  setSelectedUser(value);
                }}
                value={selectedUser}
                inputHeight={40}
              />
            </div>
          </>
        )}
        {/* {tabName === 2 && (
          <>
            <div
              className="flex justify-between items-center mt-3 gap-2"
              style={{ display: isEmployee ? "none" : "" }}
            >
              <p className="w-20 block sm:inline lg:w-auto">
                {t("common.select-user")}
              </p>

              <Combobox
                className={`!w-[300px] ${tabName === 2 ? "opacity-50 pointer-events-none" : ""
                  }`}
                options={userGroup}
                placeholder={t("common.content-161")}
                getLabel={getUserLabel}
                onChange={(value) => {
                  window.history.replaceState({}, "");
                  setSelectedUser(value);
                }}
                value={selectedUser}
                inputHeight={40}
              />
            </div>
          </>
        )} */}
        {tabName === 2 && (
          <>
            <div className="flex justify-between items-center gap-2">
              <label className="w-20 block sm:inline lg:w-auto">
                {t("common.start-time")}
              </label>
              <CustomTimePicker
                hoursLabel={false}
                // secondsEnabled={false}
                // readOnly={true}
                onTimeChange={handleDataChange}
                value={formData.startTime}
                name="startTime"
                maxHours={23}
                className="!mt-2 !w-[300px] !h-10"
              />
            </div>
            <div className="flex justify-between items-center gap-2">
              <label className="w-20 block sm:inline lg:w-auto">
                {t("common.end-time")}
              </label>
              <CustomTimePicker
                hoursLabel={false}
                // secondsEnabled={false}
                // readOnly={true}
                onTimeChange={handleDataChange}
                value={formData.endTime}
                name="endTime"
                maxHours={23}
                className="!mt-2 !w-[300px] !h-10"
              />
            </div>
          </>
        )}
        {tabName === 0 &&
          new Date(selectedDate).setHours(0, 0, 0, 0) <
          new Date().setHours(0, 0, 0, 0) && (
            <>
              <div
                className="showOnlyErrorEvents mt-3 gap-3 flex items-center justify-between"
                style={{ display: isEmployee ? "none" : "" }}
              >
                <div className="flex gap-1 items-center">
                  <Checkbox
                    id="showOnlyErrorEvents"
                    className="!p-0 !ml-[-3px]"
                    checked={formData.showOnlyErrorEvent}
                    onChange={handleCheckedChange}
                    name="showOnlyErrorEvent"
                  />
                  <p>{t("common.show-only-error-events")}</p>
                </div>

                {formData.showOnlyErrorEvent && (
                  <ControlpanelSuccessButton
                    disabled={!hasErrorRows}
                    onClick={handleOpenAddMissingCheckout} sx={{
                      borderRadius: "8px",
                      textDecoration: "none",
                    }}
                    style={{
                      color: '#fff',
                      opacity: !hasErrorRows ? '0.5' : '1',
                    }}
                  >
                    <AddIcon />
                    <p>{t("button.add-missing-checkout")}</p>
                  </ControlpanelSuccessButton>
                )}
              </div>
            </>
          )}
        {/* {tabName === 2 && (
          <>
            <div
              className="showOnlyUnknownImages mt-3 gap-3 flex items-center"
              style={{ display: isEmployee ? "none" : "" }}
            >
              <Checkbox
                id="showOnlyUnknownImages"
                className="!p-0 !ml-[-3px]"
                checked={formData.showOnlyUnknownImages}
                onChange={handleCheckedChange}
                name="showOnlyUnknownImages"
              />
              <p>{t("common.show-only-unknown-images")}</p>
            </div>
          </>
        )} */}
        {tabName === 0 && (
          <>
            <div
              className="group-events mt-3"
              style={{ display: isEmployee ? "none" : "" }}
            >
              <p>{t("common.group-events")}</p>
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  aria-label="Group Events"
                  name="groupEvents"
                  value={formData.groupEvents}
                  onChange={handleInputChange}
                >
                  <FormControlLabel
                    disabled
                    value="eventTime"
                    control={<Radio size="small" />}
                    label={t("common.event-time")}
                  />
                  <FormControlLabel
                    disabled
                    value="shiftStartTime"
                    control={<Radio size="small" />}
                    label={t("common.shift-start-time")}
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </>
        )}
        <div className="event-log-date-info p-3 shadow-primary mt-3 rounded-md flex justify-between">
          <div className="flex flex-col gap-1">
            <p className="text-base">{formattedDate}</p>
            <p className="font-semibold">{dayOfWeek}</p>
            <div className="items-center gap-1 hidden">
              <p className="font-normal mt-[2px]">
                {t("tool-tip.date-start-time")} : 00:00:00
              </p>
              <DefaultTooltip
                readMore={true}
                title={t("tool-tip.date-start-time")}
                content={
                  <div className="flex flex-col gap-3">
                    <p>
                      {t(
                        "tool-tip.day-start-time-as-defined-in-the-settings-page"
                      )}
                      .
                    </p>
                  </div>
                }
              >
                <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
              </DefaultTooltip>
            </div>
          </div>
          <div>
            <ControlpanelSuccess3thButton
              onClick={() => setSelectedDate(new Date())}
            >
              <p>{t("button.select-today")}</p>
            </ControlpanelSuccess3thButton>
          </div>
        </div>

        {hasValidUser && !isInfoEmpty && tabName !== 2 && (
          <div className="event-log-user-info p-3 shadow-primary mt-3 rounded-md flex flex-col gap-3">
            <div className="flex justify-between">
              <EmployeeInfo
                info={info}
                userData={usersData}
                profile={profile}
              />
              <p
                onClick={handleClickShowHistory}
                style={{
                  cursor: "pointer",
                  color: "#3B82F6",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                {tabName === 1 && (
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 4 }}
                  >
                    <AccessTimeIcon sx={{ width: 18, height: 18 }} />
                    <span>{t("common.show-history")}</span>
                  </div>
                )}
              </p>
            </div>

            <div className="flex justify-between items-center gap-3">
              {/* <div>{statusTemplate(info.eventType)}</div> */}
              <div>
                {tabName === 0
                  ? statusTemplate(info.eventType)
                  : statusRequest(info.requestStatusName)}
              </div>

              {/* <p className='text-base font-semibold'>{tabName === 0 ? info.eventTime : parsedNewData.timeCheckIn}</p> */}
              <div>
                <p className="text-base font-semibold">
                  {tabName === 0 ? (
                    info?.timeGMT
                      ? displayTimeByCompanyTZ(info.timeGMT, browserTZ)
                      : ""
                  ) : (
                    parsedNewData?.attendanceDateTime
                      ? displayTimeByCompanyTZ(
                        parsedNewData.attendanceDateTime, browserTZ
                      )
                      : ""
                  )}
                </p>
              </div>
            </div>

            {(
              <div className="flex items-center gap-2 self-end">
                {!isEmployee && tabName === 0 && currentInfo?.eventType !== "PENDING_CHECK_IN" && currentInfo?.eventType !== "PENDING_CHECK_OUT" && (
                  <ControlpanelPrimaryButton onClick={handleOpenEditEvent} sx={{ borderRadius: "8px", }}>
                    <PencilEditIcon16pxSvg />
                    <p>{t("button.edit")}</p>
                  </ControlpanelPrimaryButton>
                )}

                {isEmployee &&
                  (info.eventType === "CHECK_IN" || info.eventType === "CHECK_OUT" && currentInfo?.eventType !== "PENDING_CHECK_IN" && currentInfo?.eventType !== "PENDING_CHECK_OUT") && (
                    <ControlpanelPrimaryButton onClick={handleOpenEditEventByUser} sx={{ borderRadius: "8px", }}>
                      <PencilEditIcon16pxSvg />
                      <p>{t("button.request-edit")}</p>
                    </ControlpanelPrimaryButton>
                  )}

                {!isEmployee && info?.eventType && currentInfo?.eventType !== "PENDING_CHECK_IN" && currentInfo?.eventType !== "PENDING_CHECK_OUT" && (
                  <ControlpanelErrorButton onClick={handleOpenRemoveEvent}>
                    <CloseIcon />
                    <p>{t("button.delete")}</p>
                  </ControlpanelErrorButton>
                )}

                {(currentInfo?.eventType === "PENDING_CHECK_IN" || currentInfo?.eventType === "PENDING_CHECK_OUT") && currentInfo?.userId === profile.userId && (
                  <ControlpanelErrorButton onClick={handleOpenRequestRemoveEvent}>
                    <CloseIcon />
                    <p>{t("button.delete")}</p>
                  </ControlpanelErrorButton>
                )}

                {!isEmployee && info?.requestStatusName === "PENDING" && (
                  <ControlpanelPrimaryButton
                    onClick={() => {
                      markNotificationRead(info.id);
                      fetchRequestDetail(info.id, "PENDING");
                    }}
                    sx={{ borderRadius: "8px" }}
                  >
                    <InfoIcon />
                    <p>{t("button.details")}</p>
                  </ControlpanelPrimaryButton>
                )}

                {info?.requestStatusName === "PENDING" && info?.userId == profile.userId && (
                  <>
                    <ControlpanelPrimaryButton onClick={handleOpenEditRequestByUser} sx={{ borderRadius: "8px" }}>
                      <PencilEditIcon16pxSvg />
                      <p>{t("button.edit")}</p>
                    </ControlpanelPrimaryButton>
                  </>
                )}

                {info?.requestStatusName === "PENDING" && info?.userId == profile.userId && (
                  <>
                    <ControlpanelErrorButton onClick={handleOpenRemoveRequestByUser}>
                      <CloseIcon />
                      <p>{t("button.delete")}</p>
                    </ControlpanelErrorButton>
                  </>
                )}

                {(info?.requestStatusName === "APPROVED" ||
                  info?.requestStatusName === "REJECTED") && (
                    <ControlpanelPrimaryButton
                      onClick={() => { markNotificationRead(info.id); fetchRequestDetail(info.id, "AR") }}
                      sx={{ borderRadius: "8px", }}
                    >
                      <InfoIcon />
                      <p>{t("button.details")}</p>
                    </ControlpanelPrimaryButton>
                  )}
              </div>
            )}
          </div>
        )}
      </div>

      <div className="p-3 shadow-primary mt-3 rounded-md">
        {tabName === 0 && (
          <EventLogMonthEventsCalendar
            setSelectedDate={setSelectedDate}
            selectedDate={selectedDate}
            selectedShift={selectedShift}
            selectedUser={selectedUser}
            refreshData={refreshData}
            calculateDisplayedWeeks={calculateDisplayedWeeks}
            selectGroup={selectGroup}
          />
        )}
        {tabName === 1 && (
          <RequestMonthCalendar
            setSelectedDate={setSelectedDate}
            selectedDate={selectedDate}
            selectedShift={selectedShift}
            selectedUser={selectedUser}
            refreshData={refreshData}
            calculateDisplayedWeeks={calculateDisplayedWeeks}
          />
        )}
        {tabName === 2 && (
          <EventImagesCalendar
            setSelectedDate={setSelectedDate}
            selectedDate={selectedDate}
            selectedShift={selectedShift}
            selectedUser={selectedUser}
            refreshData={refreshData}
            isShowErrorIMG={isShowErrorIMG}
            calculateDisplayedWeeks={calculateDisplayedWeeks}
          />
        )}
      </div>

      {openReEvaluate && (
        <ReEvaluateDialog
          selectedDate={selectedDate}
          onClose={handleCloseReEvaluate}
        />
      )}
      {/* {openSelectDataToImport && <SelectDataToImportEventlogDialog onClose={handleCloseSelectDataToImport} />} */}
      {openSelectDataToImport && (
        <ImportDataDialog
          onClose={handleCloseSelectDataToImport}
          usersData={usersData}
          shiftsData={shiftsData}
          onRefresh={onRefresh}
        />
      )}
      {openSelectDataToExport && (
        <SelectDataToExportEventlogDialog
          onClose={handleCloseSelectDataToExport}
        />
      )}
      {openRestoreEvents && (
        <RestoreEventsDialog onClose={handleCloseRestoreEvents} />
      )}
      {openAddEvent && (
        <AddEventDialog
          open={openAddEvent}
          onClose={handleCloseAddEvent}
          usersData={usersData}
          shiftsData={shiftsDataNoAllShift}
          onRefresh={onRefresh}
          selectedDate={selectedDate}
        />
      )}
      {openAddEventFromUnidentified && (
        <AddEventFromUndefindedImage
          onClose={handleCloseAddEventFromUnidentified}
          usersData={usersData}
          shiftsData={shiftsDataNoAllShift}
          onRefresh={onRefresh}
          selectedDate={selectedDate}
        />
      )}
      {openAddMissingCheckout && (
        <AddMultiEventDialog
          onClose={handleCloseAddMissingCheckout}
          usersData={usersData}
          shiftsData={shiftsDataNoAllShift}
          onRefresh={onRefresh}
          selectedDate={selectedDate}
          preselectedUserIds={errorUserIds}
          preselectedShiftIds={getMissingCheckoutShiftIds()}
        />
      )}

      {openEditEvent && (
        <EditEventDialog
          onClose={handleCloseEditEvent}
          usersData={usersData}
          shiftsData={shiftsDataNoAllShift}
          onRefresh={onRefresh}
          info={info}
        />
      )}
      {openCheckInOut && (
        <ConfirmCheckInOutDialog onClose={handleCloseCheckInOut} shiftId={shiftId} />
      )}
      {removeEventOpen && (
        <RemoveEventDialog
          userId={profile?.userId}
          onClose={handleCloseRemoveEvent}
          onRefresh={onRefresh}
          info={info}
        />
      )}

      {requestRemoveEventOpen && (
        <RemoveRequestEventDialog
          userId={profile?.userId}
          onClose={handleCloseRequestRemoveEvent}
          onRefresh={onRefresh}
          info={info}
        />
      )}

      {openAddRequest && (
        <AddRequestDialog
          onClose={handleCloseAddRequest}
          usersData={usersData}
          shiftsData={shiftsDataNoAllShift}
          onRefresh={onRefresh}
          info={profile}
          requestTypeId={requestTypeId}
          selectedDate={selectedDate}
        />
      )}
      {openEditEventByUser && (
        <EditEventDialogByUser
          onClose={handleCloseEditEventByUser}
          usersData={usersData}
          shiftsData={shiftsDataNoAllShift}
          onRefresh={onRefresh}
          info={info}
        />
      )}
      {openEditRequestByUser && (
        <EditRequestDialogByUser
          onClose={handleCloseEditRequestByUser}
          usersData={usersData}
          shiftsData={shiftsDataNoAllShift}
          onRefresh={onRefresh}
          info={info}
          tabName={tabName}
          parsedNewData={parsedNewData}
          parsedOldData={parsedOldData}
        />
      )}
      {showHistory && (
        <HistoryDialog
          onClose={handleCloseShowHistory}
          onRefresh={onRefresh}
          requestHistory={requestHistory}
        />
      )}
      {openRequestDetail && requestInfo && (
        <DetailRequestDialog
          onClose={handleCloseRequestDetail}
          usersData={usersData}
          shiftsData={shiftsDataNoAllShift}
          onRefresh={onRefresh}
          info={requestInfo}
          tabName={tabName}
          parsedNewData={parsedNewData}
          parsedOldData={parsedOldData}
          requestHistory={requestHistory}
          onStatusResolved={(data) => {
            setRequestInfo(data);
            setOpenRequestDetail(false);
            setOpenRequestDetailAR(true);
            if (data.createdTime) {
              setSelectedDate(parseDateFromRequest(data.createdTime));
            }
          }}
        />
      )}
      {openRequestDetailAR && requestInfo && (
        <DetailRequestDialogAR
          onClose={handleCloseRequestDetailAR}
          usersData={usersData}
          shiftsData={shiftsDataNoAllShift}
          onRefresh={onRefresh}
          info={requestInfo}
          tabName={tabName}
          parsedNewData={parsedNewData}
          parsedOldData={parsedOldData}
          requestHistory={requestHistory}
        />
      )}
      {openRemoveRequestByUser && (
        <RemoveRequestDialog
          onClose={handleCloseRemoveRequestByUser}
          onRefresh={onRefresh}
          info={info}
        />
      )}

      {openEditRequestEvent && (
        <EditRequestEventDialogByUser
          onClose={handleCloseEditRequestEventByUser}
          usersData={usersData}
          shiftsData={shiftsDataNoAllShift}
          onRefresh={onRefresh}
          info={info}
          tabName={tabName}
          parsedNewData={parsedNewData}
          parsedOldData={parsedOldData}
        />
      )}
    </div>
  );
});

EventLogInfo.displayName = "EventLogInfo";

export default EventLogInfo;
